export { EmbeddedCarousel } from './embedded-carousel';
